import {
  BlockedRecordsSection,
  BlockedUserDetails,
  useBlockedUserDetails,
} from '@exam-center/blocked-user-details';
import { NavigateBackLinkWithHistory } from '@exam-center/components';
import { Flex, PageHeader, PaperSection } from '@shared/components';

export default function BlockedUserDetailsPage() {
  const { blockedUserDetails } = useBlockedUserDetails();

  return (
    <>
      <PageHeader
        title={[
          blockedUserDetails.title,
          blockedUserDetails.firstName,
          blockedUserDetails.middleName,
          blockedUserDetails.lastName,
        ]
          .filter(Boolean)
          .join(' ')}
        linkAdornment={<NavigateBackLinkWithHistory fallbackPath='/admin/blocklist' />}
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        <BlockedUserDetails />
        <PaperSection title='ข้อมูลการระงับสิทธิ์สอบ'>
          <BlockedRecordsSection />
        </PaperSection>
      </Flex>
    </>
  );
}
